import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Dialog, DialogContent, IconButton, Typography, styled } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";

import ButtonBlue from "../general/ButtonBlue";

const ACCENT = "#f15e5e";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: 20,
    boxShadow: "0 16px 48px rgba(22, 28, 45, 0.18)",
  },
});

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  width: 460,
  padding: 28,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: 20,
  },
}));

const StyledIconBadge = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 44,
  height: 44,
  borderRadius: 12,
  color: ACCENT,
  backgroundColor: "rgba(241, 94, 94, 0.12)",
});

const StyledCloseButton = styled(IconButton)({
  color: "#919eab",
  transition: "color 0.2s, background-color 0.2s",
  "&:hover": {
    color: "#454f5b",
    backgroundColor: "#f4f6f8",
  },
});

const StyledCommentPanel = styled(Box)({
  position: "relative",
  marginTop: 20,
  padding: "16px 20px",
  borderRadius: 12,
  backgroundColor: "#f9fafb",
  border: "1px solid #edeff2",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 12,
    bottom: 12,
    left: 0,
    width: 3,
    borderRadius: "0 3px 3px 0",
    backgroundColor: ACCENT,
  },
});

const StyledCommentScroll = styled(Box)({
  maxHeight: 280,
  overflowY: "auto",
  overflowWrap: "break-word",
  whiteSpace: "pre-wrap",
  "&::-webkit-scrollbar": {
    width: 6,
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 3,
    backgroundColor: "#dfe3e8",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#c4cdd5",
  },
});

const DialogCommentManager = (props) => {
  const { open, onClose, comment } = props;
  const { t } = useTranslation();

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={false}>
      <StyledDialogContent>
        <Box style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <StyledIconBadge>
            <ChatBubbleOutlineRoundedIcon />
          </StyledIconBadge>
          <Typography variant="h6" style={{ flexGrow: 1, fontWeight: 600 }}>
            {t("ReasonForDisapproval")}
          </Typography>
          <StyledCloseButton size="small" aria-label={t("Close")} onClick={onClose}>
            <CloseRoundedIcon fontSize="small" />
          </StyledCloseButton>
        </Box>

        <StyledCommentPanel>
          <StyledCommentScroll>
            {comment ? (
              <Typography style={{ lineHeight: 1.7, color: "#212b36" }}>
                {comment}
              </Typography>
            ) : (
              <Typography style={{ fontStyle: "oblique" }} color="text.secondary">
                {"-"}
              </Typography>
            )}
          </StyledCommentScroll>
        </StyledCommentPanel>

        <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
          <ButtonBlue variant="contained" onClick={onClose}>
            {t("Close")}
          </ButtonBlue>
        </Box>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default DialogCommentManager;
